<template>
  <div class="interactives-list-builder">
    <div class="list-input">
      <label v-if="inputData.label" :for="inputData.name">{{ inputData.label }}</label>
      <input
        type="text"
        :name="inputData.name"
        :placeholder="inputData.placeholder"
        v-model="newListItem"
        @keyup.enter="addNewListItem"
      >
    </div>
    <ul>
      <li is="list-item"
        v-for="(item, index) in listItems"
        :key="item.id"
        :itemContent="item.content"
        @remove="removeListItem"
      />
    </ul>
  </div>
</template>

<script>
import ListItem from './ListItem.vue'

export default {
  name: 'interactives-check-input',
  props: ['inputData'],
  data () {
    return {
      newListItem: '',
      nextItemId: this.inputData.value.length,
      listItems: this.inputData.value.slice(0)
    }
  },
  components: {
    'list-item': ListItem
  },
  methods: {
    addNewListItem: function () {
      this.listItems.push({
        id: this.nextItemId++,
        content: this.newListItem
      })
      this.inputData.value.push(this.newListItem)
      this.newListItem = ''
    },
    removeListItem: function (index) {
      this.listItems.splice(index, 1)
      this.inputData.value.splice(index, 1)
    }
  }
}
</script>

<style>
.interactives-check-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/components/ListBuilder.vue